export const endChatFlow = ({ createdAt }: { createdAt: string }) => {
  return {
    text: 'Obrigado por entrar em contato! Clique em <strong>Recomeçar conversa</strong> para outra conversa.',
    from: 'bot',
    time: createdAt || new Date().toISOString()
  }
}
